<template>
  <div>
    <!-- INTRO PAGE-->
    <v-row id="home" align="center" justify="center">
      <v-col cols="5" md="5">
        <div class="headline grey--text ml-2">We are creative</div>
        <div class="font-weight-bold my-4 display-3">
          JETLIGHT
          <span class="display-3">Studio</span>
        </div>
        <div class="subtitle-1 grey--text">
          "All platforms, One studio" is our company's moto.
          <br />we are a multi-platform developpement studio, we offer various software services.
        </div>

        <v-btn color="#082543" x-large class="rounded-xl white--text mr-3 mt-4 px-4">
          <v-icon left>work</v-icon>
          <span>Hire Us</span>
        </v-btn>

        <v-btn
          @click="$vuetify.goTo('#contact',options)"
          color="#082543"
          x-large
          class="rounded-xl white--text mt-4 px-4"
        >
          <v-icon left>call</v-icon>
          <span>Contact Us</span>
        </v-btn>
      </v-col>
      <v-col cols="1" md="1" />
      <v-col cols="5" md="5">
        <v-img src="/home.png" />
      </v-col>
    </v-row>

    <v-spacer style="height: 8vh" />

    <!-- SERVICES PAGE-->
    <div id="services">
      <div class="text-center font-weight-bold display-2">Our Services</div>
      <div class="text-center my-4">
        <span class="grey--text body-1">
          We offer a wide veriety of services tailored to your every need.
          <br>No matter the project, our team has experience dealing with every platform and will deliver high quality software.
        </span>
      </div>
      <Services />
    </div>

    <v-spacer style="height: 8vh" />
    <!-- PORTFOLIO PAGE-->
    <div id="portfolio">
      <div class="text-center font-weight-bold display-2">Our Recent Works</div>
      <div class="text-center my-4">
        <span class="grey--text body-1">
          JetLight studio's creations speak for themselfs, check out our professional work
          <br />already published and currently available for client usage.
        </span>
      </div>
      <Portfolio />
    </div>
    <v-spacer style="height: 8vh" />

    <!-- OUR TEAM PAGE-->
    <div id="team"  class="text-center font-weight-bold display-2">Our Team</div>
    <div class="text-center my-4">
      <span class="grey--text body-1">
        Our highly motivated and capable team is ready to offer services, consulting and more! Contact us to obtain our help setting up your next project.
      </span>
    </div>
    <Team />

    <v-spacer style="height: 8vh" />

    <!-- TESTIMONIAL PAGE-->
    <div id="testimonial">
      <h1 class="text-center font-weight-bold display-2">They Trust Us</h1>
      <div class="text-center my-4">
        <span class="grey--text body-1">
          Some of our partners and clients saying a few words about us.
        </span>
      </div>
      <Testimonial />
    </div>

    <v-spacer style="height: 8vh" />

    <!--EVENT PAGE-->
    <Event />
    <v-spacer style="height: 8vh" />
    <!--CONTACT PAGE-->
    <div id="contact">
      <div class="text-center font-weight-bold display-2">Get in touch with us</div>
      <div class="text-center my-4">
        <span class="grey--text body-1">Anything On your Mind. We’ll Be Glad To Assist You!</span>
      </div>
      <Contact />
    </div>
  </div>
</template>
<script>
import Contact from "@/components/Contact.vue";
import Services from "@/components/Services.vue";
import Portfolio from "@/components/Portfolio.vue";
import Testimonial from "@/components/Testimonial.vue";
import Event from "@/components/Event.vue";
import Team from "@/components/Team.vue";

export default {
  name: "home",
  components: {
    Contact,
    Services,
    Portfolio,
    Testimonial,
    Event,
    Team
  },
  data() {
    return {
      features: [
        {
          role: "Advertising",
          avatar: "/feature1.png",
          text:
            "Lorem ipsum dolor sit amet elit, adipiscing, sed do eiusmod tempor incididunt ut labore dolore magna aliqua."
        },
        {
          role: "Strategy & Research",
          avatar: "/feature3.png",
          text:
            "Lorem ipsum dolor sit amet elit, adipiscing, sed do eiusmod tempor incididunt ut labore dolore magna aliqua."
        },
        {
          role: "Design & Development",
          avatar: "/feature2.png",
          text:
            "Lorem ipsum dolor sit amet elit, adipiscing, sed do eiusmod tempor incididunt ut labore dolore magna aliqua."
        },
        {
          role: "Branding & Marketing",
          avatar: "/feature1.png",
          text:
            "Lorem ipsum dolor sit amet elit, adipiscing, sed do eiusmod tempor incididunt ut labore dolore magna aliqua."
        }
      ],
      teams: [
        {
          title: "BENOTMANE Mohammed",
          text: `Full Stack Web Developer`,
          img: "/team3.jpg"
        },
        { title: "BONNOR Oussama", text: "Game Developer", img: "/team3.jpg" },
        { title: "SMAHI Amine", text: "Net Developer", img: "/team3.jpg" }
      ],
      options: {
        duration: 1500,
        offset: 0,
        easing: "easeInOutCubic"
      }
    };
  }
};
</script>

<style>
</style>